// @greenlight-spec: 10-security-compliance.md
// @greenlight-spec: 16-api-conventions.md
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { OrgRoleSchema, PaginationQuerySchema, UserListItemSchema, UserSchema, paginated, } from '@greenlight/shared';
import { errorResponses } from './common.js';
const c = initContract();
const UserIdParamsSchema = z.object({ id: z.string().uuid() });
export const InviteUserSchema = z.object({
    email: z.string().email(),
    displayName: z.string().min(1).max(255).optional(),
    role: OrgRoleSchema,
});
export const UpdateUserSchema = z
    .object({
    displayName: z.string().min(1).max(255),
    role: OrgRoleSchema,
    isActive: z.boolean(),
})
    .partial();
export const usersContract = c.router({
    list: {
        method: 'GET',
        path: '/api/users',
        query: PaginationQuerySchema,
        responses: {
            200: paginated(UserListItemSchema),
            ...errorResponses,
        },
        summary: 'List users in the org (cursor-paginated by email asc).',
    },
    invite: {
        method: 'POST',
        path: '/api/users',
        body: InviteUserSchema,
        responses: {
            201: UserSchema,
            ...errorResponses,
        },
        summary: 'Invite a new user into the org (IdP must back the email).',
    },
    update: {
        method: 'PATCH',
        path: '/api/users/:id',
        pathParams: UserIdParamsSchema,
        body: UpdateUserSchema,
        responses: {
            200: UserSchema,
            ...errorResponses,
        },
        summary: 'Update role, display name, or active flag for a user.',
    },
});
//# sourceMappingURL=users.js.map